import { createRouter, createWebHistory } from 'vue-router';

// Route components are dynamically imported as before
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/videos',
    name: 'Videos',
    component: () => import('@/views/Videos.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // Add a catch-all route for 404 if desired
  // { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundComponent },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // Use createWebHistory for history mode
  routes,
});

// Navigation guards (like checking meta.requiresAuth) need to be re-added here
// using router.beforeEach((to, from, next) => { ... }) if they were previously
// handled elsewhere (e.g., in boots/auth.js or main.js).
// We will check boots/auth.js later.

export default router;
